import * as types from './actionTypes';

let initialState = {
    ticketList: [],
    ticketComments: [],
    ticketInfo: {},
    ticketUsers: []
}


export default function reducer(state = initialState, action) {
    switch (action.type) {
        case types._INIT_TICEKT_LIST: {
            const ticketList = action.request.data.tickets;
            return {
                ...state,
                ticketList: ticketList,
            };
        }

        case types._ADD_TICKET: {
            const newTicket = action.request.data.ticket;
            return {
                ...state,
                ticketList: [newTicket, ...state.ticketList]
            }
        }

        case types._CLOSE_TICKET: {
            state.ticketInfo.status = 'solved';
            return {
                ...state,
                ticketInfo: {...state.ticketInfo}
            }
        }

        case types._GET_TICEKT: {
            return {
                ...state,
                ticketComments: action.request.data.comments,
                ticketInfo: action.request.data.ticket,
                ticketUsers: action.request.data.users
            }
        }

        case types._ADD_TICKET_COMMENT: {
            const newComment = action.request.data.comment;

            return {
                ...state,
                ticketComments: [newComment, ...state.ticketComments]
            }
        }

        default:
            return state;
    }

}
